import commonService from './common-service';

class KOPService {
  async getKopList() {
    try {
      const response = await commonService.getFromServer('KOPList', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
}

export default new KOPService();
